import { useEffect } from 'react';

export const useOnPixelRatioChange = (
  onChange: (event: MediaQueryListEvent) => void,
): void => {
  useEffect(() => {
    let pixelRatio = window.devicePixelRatio;
    let media = matchMedia(`(resolution: ${pixelRatio}dppx)`);

    const handleChange = (event: MediaQueryListEvent): void => {
      onChange(event);

      // Re-evaluate media query when devicePixelRatio changes
      if (window.devicePixelRatio !== pixelRatio) {
        pixelRatio = window.devicePixelRatio;
        media.removeEventListener('change', handleChange);
        media = matchMedia(`(resolution: ${pixelRatio}dppx)`);
        media.addEventListener('change', handleChange);
      }
    };

    media.addEventListener('change', handleChange);

    return () => {
      media.removeEventListener('change', handleChange);
    };
  }, [onChange]);
};
